// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCanvasMessageVariationsForUcoCanvasIdStepIdResult = objectOf({
  variations: arrayOf(objectOf({ id: string, name: string, channel: string, title: string, message: string })),
});
